import { KendoBaseComponent, KendoBaseDatasourceComponent } from '@progress/kendo-base-components-vue-wrapper'
import ListBoxProps from './ListBoxProps'

import Draggable from './Draggable'
import Messages from './Messages'
import Toolbar from './Toolbar'

export default {
    props: ListBoxProps,
    emits: {
        'kendowidgetready': null
    },
    mixins: [
        KendoBaseComponent,
        KendoBaseDatasourceComponent,
        Draggable,
        Messages,
        Toolbar
    ],
    mounted() {
        kendo.jQuery(this.$el).kendoListBox(this.widgetOptions)

        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoListBox()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-listbox-vue-wrapper/src/KendoListBox/KendoListBoxMixin.js